export default class EnumService {
    /**
     * Creates a function to return the key of a enum as a string given the value
     * **Should only be used in rare situations.  Enums generally should only be compared using value**
     *
     * @param {object} enumObject - the enum.  Should be an object with primitive values
     * @returns {function(valueof T): void|keyof T} a function that returns the key of the enum given the value
     */
    static createValueFinder(enumObject) {
        return (val) => // $FlowFixMe
         
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'keyof T'. | TS2769 - No overload matches this call. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'unknown'.
        Object.keys(enumObject).find((key) => enumObject[key] === val);
    }
}
